// 赛意信息
import Overview from '@rebuild/materials/shared/announcement/OverviewIndex.vue';
import Full from '@rebuild/materials/shared/announcement/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/announcement/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/announcement/mobile/FullIndex.vue';

import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/announcement/context';
import i18n, { EN, languageTypeMap } from '@/locales';

function useSelfContext() {
	const isENSie = i18n.locale == EN;
	const languageType = isENSie ? { languageType: 0 } : { languageType: languageTypeMap[i18n.locale] };

	provideCurrentContext({
		languageType
	});
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(Full, useSelfContext),
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext)
};
